import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const err = (e) => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : "Request failed"; };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-GB") : "no expiry");

export const WaSystemTokenForm = ({ pinned, onDone, renew = false, onCancel }) => {
  const [tok, setTok] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/wa/cloud/connection/system-token", { access_token: tok.trim() });
      toast.success(`${data.renewed ? "Access token renewed" : `Connected ${data.display_phone_number || data.phone_number_id}`}. Expires: ${fmt(data.token_expires_at)}. Webhook ${data.webhook_subscribed ? "subscribed" : "NOT subscribed"}. Sending stays locked.`);
      onDone();
    } catch (e) { toast.error(err(e)); } finally { setTok(""); setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50/50 p-3 space-y-2" data-testid="wa-system-token-form">
      <p className="text-xs font-semibold text-slate-800 flex items-center gap-1.5"><KeyRound className="w-4 h-4 text-sky-700" />{renew ? "Renew access token" : "Meta test account (App Review demo only)"}</p>
      <p className="text-xs text-slate-600">Only WhatsApp account <code>{pinned.waba_id}</code> and phone number ID <code>{pinned.phone_number_id}</code> are accepted. The token is checked with Meta, {renew ? "replaces the old one (the account is not disconnected), " : ""}is stored encrypted and is never shown again. Sending stays locked.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input type="password" autoComplete="off" value={tok} onChange={(e) => setTok(e.target.value)} placeholder={renew ? "Paste fresh Meta access token" : "System-user access token"} className="h-9" data-testid="wa-system-token-input" />
        <Button size="sm" onClick={save} disabled={busy || tok.trim().length < 40} data-testid="wa-system-token-save">{busy && <Loader2 className="w-4 h-4 animate-spin mr-1" />}{renew ? "Check and renew" : "Check and connect"}</Button>
        {onCancel && <Button size="sm" variant="ghost" onClick={onCancel} data-testid="wa-system-token-cancel">Cancel</Button>}
      </div>
    </div>
  );
};
